module.exports = __webpack_public_path__ + "static/media/right_arrow_table.c064eda0.svg";